import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Tags = ({ children, className, ...props }) => (
  <ul className={classnames('tags', className)} {...props}>
    {children}
  </ul>
);

Tags.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  className: PropTypes.string
};

export default Tags;
